/* src/app/features/honra/consulta-ipoc/abas/troca-ipoc/aba-troca-ipoc.component.scss */
.stroke {
  text-decoration: line-through;
}
/*# sourceMappingURL=aba-troca-ipoc.component.css.map */
